
import Basket from '../models/Basket';
import Resource from "../models/Resource";

const storage = localStorage;

/**
 * Session class
 * @class
 */
class Session
{
    /**
     * Session basket
     * @type {Basket}
     */
    basket: Basket;


    get( attribute )
    {
        return storage.getItem( attribute );
    }


    has( attribute )
    {
        return this.get( attribute ) !== null;
    }


    put( resource: Resource )
    {
        if( ! resource.exists )
            return;

        storage.setItem( resource.class.handle, resource[resource.class.handle] );
    }


    delete( attribute )
    {
        storage.removeItem( attribute );
    }
}

(window as any).s = Session;

export default new Session;
